import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

type TabBarStyleProps = { activeIndex: number; tabWidth: number };

export const tabBarStyle = ({ activeIndex, tabWidth }: TabBarStyleProps) => css`
  width: 100%;

  /* Prevents inadvertent collapsing inside a flex parent */
  min-height: 40px;
  height: 40px;
  display: flex;
  position: relative;

  :focus {
    outline: none;
  }

  ::after {
    content: '';
    display: block;
    height: 2px;
    background: ${theme.colors.primary50};
    position: absolute;
    bottom: -1px;
    left: 0;
    transition: transform 0.3s ease-out;
    width: ${tabWidth}%;
    opacity: ${activeIndex >= 0 ? 1 : 0};
    transform: translateX(${100 * activeIndex}%);
  }

  a,
  button {
    min-width: ${tabWidth}%;
    flex-basis: ${tabWidth}%;
  }
`;

export const tabItemStyle = css`
  font-family: ${theme.font.family};
  font-size: ${theme.font.size.medium};
  color: ${theme.font.colors.light};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  text-decoration: none;
  transition: background 0.25s ease-out;

  :hover,
  :focus {
    background: ${theme.colors.neutral5};
    color: ${theme.colors.neutral80};
    outline: none;
  }

  &.selected,
  &[aria-selected='true'] {
    color: ${theme.colors.primary50};
    font-weight: ${theme.font.weight.bold};

    :focus::after {
      background: ${theme.colors.neutral80};
    }
  }
`;

export const TabFilterStyles = {
  tabItem: tabItemStyle,
  tabBar: (tabBarProps: TabBarStyleProps) => tabBarStyle(tabBarProps),
};
